import { AVAILABLE_REWARD } from "../actions/types";

let rewardDataState = {reward: [], totalPages: 0, currentPage: 1 };


export default function (state = rewardDataState, action) {
    switch (action.type) {
        case AVAILABLE_REWARD:
            if (state.reward.length === 0) {
                return {
                    ...state,
                    reward: action.payload.content.rewards,
                    totalPages: action.payload.content.totalPages,
                    currentPage: parseInt(action.payload.content.currentPage),
                }
            } else {
                let concatResult = {};
                concatResult.reward = state.reward.concat(action.payload.content.rewards);
                concatResult.totalPages = action.payload.content.totalPages;
                concatResult.currentPage = parseInt(action.payload.content.currentPage);
                return {
                    ...state,
                    reward: concatResult.reward,
                    totalPages: concatResult.totalPages,
                    currentPage: concatResult.currentPage,
                }
            }

        
        default:
            return state;
    }
}